import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.empty');
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-empty',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.empty/view.scss */
:host {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}`],
})
export class LayoutEmptyComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  public ref: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init(this);
    }
}

export default LayoutEmptyComponent;